import { useWidgetContext } from 'widgets/WidgetContext.tsx';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks.ts';
import useWidgetStream from 'widgets/streaming/useWidgetStream.ts';
import React, { useState } from 'react';
import VolumeCurveHeader from 'widgets/volumeCurve/components/VolumeCurveHeader.tsx';
import { VolumeCurveContent } from 'widgets/volumeCurve/components/VolumeCurveContent.tsx';
import './VolumeCurve.scss';
import { GridApi } from '@instinet-analytics/semantic-ui-components';
import {
    useVolumeCurveData,
    VolumeCurveData,
} from 'widgets/volumeCurve/data/volumeCurveData.ts';
import { XAxisContextProvider } from 'utils/components/TimeSeriesChart/XAxisContext.tsx';
import { useVolumeCurveDimensions } from 'widgets/volumeCurve/components/dimensions.ts';

export default function VolumeCurve() {
    const { widgetKey, width } = useWidgetContext();
    const data = useVolumeCurveData();

    const [gridApi, setGridApi] = useState<GridApi | undefined>();

    useWidgetStream();

    const { bodyHeight } = useVolumeCurveDimensions();

    return (
        <div className="VolumeCurve" data-widget-id={widgetKey}>
            <XAxisContextProvider
                timeSeriesChartWidth={width}
                startTime={data.startTimestamp}
                endTime={data.endTimestamp}
                breaks={data.breaksInTrading}
                rangeLabels={[]}
                timeLineLabels={[]}
                allowZoom={false}
            >
                <VolumeCurveHeader
                    messages={[]}
                    gridApi={gridApi}
                    data={data}
                />

                <div className="widget-body" style={{ height: bodyHeight }}>
                    <WidgetBody onGridApiSet={setGridApi} data={data} />
                </div>
            </XAxisContextProvider>
        </div>
    );
}

export function WidgetBody({
    data,
    onGridApiSet,
}: {
    data: VolumeCurveData;
    onGridApiSet: (gridApi: GridApi) => void;
}) {
    const { hasValidSelection } = useWidgetPortfolioSelectionStatus();
    if (!hasValidSelection) {
        return <></>;
    }

    return <VolumeCurveContent onGridApiSet={onGridApiSet} data={data} />;
}
